import React from 'react'
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';
import AdminLayout from './AdminLayout';

export const SEO = ({ title }) => {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

export const EngineAdmin = observer(() => {
   return (
    <>
      <SEO title="Simulcast Portal - Custom Engine Tools" />
      <AdminLayout />
    </>
  );
});

export default EngineAdmin;